/**
 * Return a keyword to describe a numeric score value. These keywords are not
 * provided by Open Planet, so they had to be added manually and therefore,
 * accuracy is not guaranteed.
 * @param  {String} provider Rating provider; provided by Open Planet
 * @param  {Number} score    Numeric score value; provided by Open Planet
 * @return {String}          Keyword that describes the score
 */
export function ratingScoreDescription(provider, scoreString) {
  const score = parseFloat(scoreString, 10);
  if (provider === "bdc") {
    if (score >= 9) return "Awesome";
    if (score >= 8) return "Very good";
    if (score >= 7) return "Good";
    if (score >= 6) return "Pleasant";
    if (score < 6) return "Review score";
  }

  if (provider === "hostelworld") {
    if (score >= 90) return "Superb";
    if (score >= 80) return "Fabulous";
    if (score >= 70) return "Very good";
    if (score >= 60) return "Good";
    if (score < 60) return "Review score";
  }

  return "";
}

/**
 * Returns a string describing a lodging's rating
 * @param  {String} provider Rating provider; provided by Open Planet
 * @param  {Number} score    Numeric score value; provided by Open Planet
 * @return {String}          String that describes the score
 */
export function ratingCopy(provider, score) {
  return provider
    ? `${ratingScoreDescription(provider, score)} ${score} out of ${provider === "bdc" ? 10 : 100}`
    : "";
}



// WEBPACK FOOTER //
// ./assets/shared/lodgingRating.js